import { KYMW1901Component } from './kymw1901.component';

/**
 * 掲載組合員の声出力画面の値を管理するクラス
 *
 * @export KYMW1901Model
 * @class KYMW1901Model
 */
export class KYMW1901Model {

  kymw1901Component: KYMW1901Component;

  // 【画面項目】
  /**
   * 受注コード
   */
  public orderCode: string = <string>'';

  /**
   * 配達企画回（翌週）
   */
  public delivCatalogID: string = <string>'';

  // 【内部項目】
  /**
   * 組合員の声出力件数
   */
  public membersVoiceOutputNum: number = <number>0;

  /**
   * ファイル名
   */
  public fileName: string = <string>'';

  /**
   * サーバからの受信データにて組合員の声出力件数を更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getMembersVoiceOutputNum(serverData: any): void {
    // 組合員の声出力件数をview項目に設定する
    this.membersVoiceOutputNum = serverData.TotalNum;
  }

  /**
   * サーバからの受信データにてファイル名を更新する
   *
   * @param serverData サーバからの受信データ
   */
  public getMembersVoiceOutputCSV(serverData: any): void {
    // ファイル名をview項目に設定する
    this.fileName = serverData.FileUrl;
  }

}
